import api from "_config/api";

// Geometria (GeoJSON) do lote fiscal devolvida pelo backend (Polygon, SRID 4326,
// com bbox). O System.Text.Json + GeoJsonConverterFactory serializa como objeto
// GeoJSON padrão, diretamente consumível por <GeoJSON data={...}> do react-leaflet.
export type GeometriaLote = {
  type: string;
  // coordinates/geometries dependem do type; mantido genérico para o <GeoJSON>.
  [key: string]: unknown;
} | null;

// Endereço do lote fiscal (origem: CadastroImovel). Obs.: hoje o backend NÃO
// devolve bairro/cidade/uf aqui.
export interface EnderecoLoteFiscal {
  cep?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
  quadra?: string | null;
  numeroLote?: string | null;
  matricula?: string | null;
}

// Proprietário = CONTRIBUINTE vinculado ao lote (Imobiliário Fiscal). Editável no
// formulário; é apenas sugestão de preenchimento (autodeclaração no envio).
export interface ProprietarioLoteFiscal {
  nome?: string | null;
  cpfCnpj?: string | null;
  cep?: string | null;
  logradouro?: string | null;
  tipoLogradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
  telefone?: string | null;
  email?: string | null;
}

export interface DadosLoteFiscal {
  loteFiscalIdentificado: boolean;
  idLoteFiscal?: string | null;
  latitude: number;
  longitude: number;
  geometriaLote?: GeometriaLote;
  endereco?: EnderecoLoteFiscal | null;
  proprietarios: ProprietarioLoteFiscal[];
}

/**
 * Verifica se a coordenada cai dentro da geometria de um lote fiscal.
 * Rota: GET api/v1/cidadao/licenciamentourbano/fiscal/verificar-lote?latitude=&longitude=
 *
 * ⚠️ Contrato: o backend SEMPRE responde 200 com o DTO. Quando não há lote,
 * `loteFiscalIdentificado=false` (nunca 204). Por isso decidimos pelo flag, não
 * pelo status. Retorna null apenas em resposta vazia/inesperada.
 */
export const fetchVerificarLoteFiscal = async (
  latitude: number,
  longitude: number
): Promise<DadosLoteFiscal | null> => {
  const { data, status } = await api.get<DadosLoteFiscal>(
    `api/v1/cidadao/licenciamentourbano/fiscal/verificar-lote`,
    { params: { latitude, longitude } }
  );

  if (status === 204 || !data) return null;
  return data;
};
